import gql from 'graphql-tag';

const GET_ORDER_LOGBOOK = gql`
  # Write your query or mutation here
  
  query getLogByOrderId($orderId: String) {
    getLogByOrderId(orderId: $orderId) {
      count
      page
      pageSize
      results {
        ... on LogOrder {
          idOrder
          comment
          user
          phone
          contactType
          createdAt
          dataSource
        }
      }
    }
  }
`;

export default GET_ORDER_LOGBOOK;
